import { render, staticRenderFns } from "./ItemGroupSelectBehaviorEditor.vue?vue&type=template&id=52301100&"
import script from "./ItemGroupSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupSelectBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports